export const WARRANTY = "WARRANTY";
export const PAID_REPAIR = "PAID_REPAIR";
export const SUPPORT = "SUPPORT";
